export default () => ({
    container: {
        flexDirection: 'row',
        padding: '32px 96px',
    },
    wrapper: {
        padding: 8,
    },
});
